/**
 * @private
 */
export const observeMediaQuery = (query, cb) => {
  let supportModernApi;
  // Safari makes MediaQueryList object private, so we can't check support of modern api
  try {
    supportModernApi = 'addEventListener' in query;
  } catch (e) {
    supportModernApi = false;
  }
  let unsub = () => {};
  const listener = event => cb(event, unsub);
  if (supportModernApi) {
    query.addEventListener('change', listener, {
      passive: true
    });
    unsub = () => query.removeEventListener('change', listener);
  } else {
    query.addListener(listener);
    unsub = () => query.removeListener(listener);
  }
  return unsub;
};